import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c6f1ad0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat" }
const _hoisted_2 = {
  key: 0,
  class: "loader"
}
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "actions" }
const _hoisted_6 = { class: "list-wrapper" }
const _hoisted_7 = {
  key: 0,
  class: "list"
}
const _hoisted_8 = {
  key: 0,
  class: "message-loader"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Weitere Nachrichten werden geladen...", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "list-spacer",
  id: "end-of-list"
}, null, -1))
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "chat-empty" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_indicator_circular = _resolveComponent("md-progress-indicator-circular")!
  const _component_md_badge = _resolveComponent("md-badge")!
  const _component_md_button = _resolveComponent("md-button")!
  const _component_md_tooltip = _resolveComponent("md-tooltip")!
  const _component_snooze_wrapper = _resolveComponent("snooze-wrapper")!
  const _component_transition_fade = _resolveComponent("transition-fade")!
  const _component_day_separator = _resolveComponent("day-separator")!
  const _component_text_message = _resolveComponent("text-message")!
  const _component_template_message = _resolveComponent("template-message")!
  const _component_contact_message = _resolveComponent("contact-message")!
  const _component_image_message = _resolveComponent("image-message")!
  const _component_video_message = _resolveComponent("video-message")!
  const _component_audio_message = _resolveComponent("audio-message")!
  const _component_file_message = _resolveComponent("file-message")!
  const _component_note_message = _resolveComponent("note-message")!
  const _component_user_payload_message = _resolveComponent("user-payload-message")!
  const _component_buttons_message = _resolveComponent("buttons-message")!
  const _component_chat_input_field = _resolveComponent("chat-input-field")!
  const _component_empty_hint = _resolveComponent("empty-hint")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.conversation && _ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_md_progress_indicator_circular, { size: "large" })
        ]))
      : _createCommentVNode("", true),
    (_ctx.conversation && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.conversation.displayName), 1),
              (_ctx.snoozedTime)
                ? (_openBlock(), _createBlock(_component_md_badge, {
                    key: 0,
                    class: "badge",
                    state: "info",
                    icon: true,
                    size: "medium",
                    "icon-name": "history"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.snoozedTime), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_5, [
              (!_ctx.conversation.archived)
                ? (_openBlock(), _createBlock(_component_md_tooltip, {
                    key: 0,
                    position: "bottom",
                    text: "Archivieren"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_md_button, {
                        variant: "icon",
                        grey: "",
                        icon: "archive",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.archive(true)))
                      })
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_md_tooltip, {
                    key: 1,
                    position: "bottom",
                    text: "Nicht mehr archivieren"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_md_button, {
                        variant: "icon",
                        grey: "",
                        icon: "unarchive",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.archive(false)))
                      })
                    ]),
                    _: 1
                  })),
              (!_ctx.conversation.unread)
                ? (_openBlock(), _createBlock(_component_md_tooltip, {
                    key: 2,
                    position: "bottom",
                    text: "Als ungelesen markieren",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setUnread()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_md_button, {
                        variant: "icon",
                        grey: "",
                        icon: "mark_as_unread"
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_md_button, {
                variant: "text",
                icon: "schedule",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.snoozeActive = !_ctx.snoozeActive))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Zurückstellen")
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_transition_fade, null, {
              default: _withCtx(() => [
                (_ctx.snoozeActive)
                  ? (_openBlock(), _createBlock(_component_snooze_wrapper, {
                      key: 0,
                      onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.snoozeActive = false)),
                      ref: "snoozeWrapper"
                    }, null, 512))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_ctx.messages && _ctx.messages.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_ctx.loadingMessages)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _hoisted_9,
                        _createVNode(_component_md_progress_indicator_circular, { size: "small" })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.canLoadMoreMessages && !_ctx.loadingMessages)
                    ? (_openBlock(), _createBlock(_component_md_button, {
                        key: 1,
                        variant: "text",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadMoreMessages()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Weitere Nachrichten laden")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (msg, k) => {
                    return (_openBlock(), _createElementBlock("div", { key: k }, [
                      (
                k > 0 &&
                msg.created &&
                _ctx.messages[k - 1].created &&
                !_ctx.isSameDay(msg.created, _ctx.messages[k - 1].created)
              )
                        ? (_openBlock(), _createBlock(_component_day_separator, {
                            key: 0,
                            message: msg
                          }, null, 8, ["message"]))
                        : _createCommentVNode("", true),
                      (msg.type === 'text')
                        ? (_openBlock(), _createBlock(_component_text_message, {
                            key: 1,
                            message: msg
                          }, null, 8, ["message"]))
                        : (msg.type === 'template')
                          ? (_openBlock(), _createBlock(_component_template_message, {
                              key: 2,
                              message: msg
                            }, null, 8, ["message"]))
                          : (msg.type === 'user_text')
                            ? (_openBlock(), _createBlock(_component_text_message, {
                                key: 3,
                                message: msg
                              }, null, 8, ["message"]))
                            : (msg.type === 'contact')
                              ? (_openBlock(), _createBlock(_component_contact_message, {
                                  key: 4,
                                  message: msg
                                }, null, 8, ["message"]))
                              : (msg.type === 'image')
                                ? (_openBlock(), _createBlock(_component_image_message, {
                                    key: 5,
                                    message: msg
                                  }, null, 8, ["message"]))
                                : (msg.type === 'video')
                                  ? (_openBlock(), _createBlock(_component_video_message, {
                                      key: 6,
                                      message: msg
                                    }, null, 8, ["message"]))
                                  : (msg.type === 'audio')
                                    ? (_openBlock(), _createBlock(_component_audio_message, {
                                        key: 7,
                                        message: msg
                                      }, null, 8, ["message"]))
                                    : (msg.type === 'file' || msg.type === 'document')
                                      ? (_openBlock(), _createBlock(_component_file_message, {
                                          key: 8,
                                          message: msg
                                        }, null, 8, ["message"]))
                                      : (msg.type === 'note')
                                        ? (_openBlock(), _createBlock(_component_note_message, {
                                            key: 9,
                                            message: msg
                                          }, null, 8, ["message"]))
                                        : (msg.type === 'user_payload')
                                          ? (_openBlock(), _createBlock(_component_user_payload_message, {
                                              key: 10,
                                              message: msg
                                            }, null, 8, ["message"]))
                                          : (msg.type === 'buttons')
                                            ? (_openBlock(), _createBlock(_component_buttons_message, {
                                                key: 11,
                                                message: msg
                                              }, null, 8, ["message"]))
                                            : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  _hoisted_10
                ]))
              : _createCommentVNode("", true)
          ])), [
            [_directive_infinite_scroll, [
          _ctx.loadMoreMessages,
          { direction: 'top', preserveScrollPosition: true },
        ]]
          ]),
          _createVNode(_component_chat_input_field, { class: "chat-input-field" })
        ], 64))
      : _createCommentVNode("", true),
    (!_ctx.conversation && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_empty_hint, {
              title: "Keine Konversation geöffnet",
              description: "Klicke eine Konversation auf der linken Seite an, damit diese hier angezeigt wird."
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}